import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useLang } from '@/hooks/use-lang'
import { t } from '@/lib/i18n'
import { api } from '@/lib/api'
import { Wordmark } from '@/components/wordmark'

export function ForgotPasswordPage() {
  useLang()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      // Anti-enumeration: the backend always returns 200; we show the same
      // confirmation regardless of whether the email maps to an account.
      await api.post('/api/auth/forgot-password', { email })
    } catch {
      // Swallow errors so the response can't be used to probe for accounts.
    } finally {
      setSent(true)
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg)' }}>
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <img src="/logo.png" className="w-12 h-12 mx-auto mb-4" alt="WebhookLens" />
          <h1 className="text-xl font-semibold" style={{ color: 'var(--white)' }}><Wordmark /></h1>
          <p className="text-sm mt-1" style={{ color: 'var(--muted)' }}>{t('forgotPasswordTitle')}</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 p-6 rounded-xl" style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border)' }}>
          {sent ? (
            <p className="text-sm p-3 rounded-lg text-center" style={{ color: 'var(--accent-ink, var(--accent))', backgroundColor: 'var(--accent-soft)', border: '1px solid color-mix(in srgb, var(--accent) 25%, transparent)' }}>
              {t('resetLinkSent')}
            </p>
          ) : (
            <>
              <p className="text-sm" style={{ color: 'var(--muted)' }}>{t('forgotPasswordDesc')}</p>
              <div>
                <label className="block text-xs font-medium mb-1.5" style={{ color: 'var(--muted)' }}>{t('email')}</label>
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  className="w-full px-3 py-2 rounded-lg text-sm focus:outline-none transition"
                  style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text)' }}
                  onFocus={e => (e.target as HTMLInputElement).style.borderColor = 'var(--accent)'}
                  onBlur={e => (e.target as HTMLInputElement).style.borderColor = 'var(--border)'}
                />
              </div>
              <button type="submit" disabled={loading}
                className="btn-accent w-full py-2.5 rounded-lg text-sm font-medium"
              >
                {t('sendResetLink')}
              </button>
            </>
          )}
          <p className="text-sm text-center" style={{ color: 'var(--muted)' }}>
            <Link to="/login" className="font-medium transition" style={{ color: 'var(--accent)' }}
              onMouseEnter={e => (e.currentTarget as HTMLElement).style.color = 'var(--accent-bright)'}
              onMouseLeave={e => (e.currentTarget as HTMLElement).style.color = 'var(--accent)'}
            >
              {t('backToLogin')}
            </Link>
          </p>
        </form>
      </div>
    </div>
  )
}
